import { useEffect, useState } from "react";
import { Smartphone, Share, X } from "lucide-react";
import { Button } from "./ui/button";

const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export default function InstallHint({ compact = false }) {
  const [prompt, setPrompt] = useState(null);
  const [hidden, setHidden] = useState(() => localStorage.getItem("supplivo_install_hint_hidden") === "1");
  const [standalone] = useState(isStandalone);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  if (standalone || (compact && hidden)) return null;
  const install = async () => { if (!prompt) return; prompt.prompt(); await prompt.userChoice; setPrompt(null); };
  const dismiss = () => { localStorage.setItem("supplivo_install_hint_hidden", "1"); setHidden(true); };

  return (
    <div className={`bg-slate-950 text-slate-100 rounded-lg p-4 ${compact ? "lg:hidden" : ""} relative`} data-testid="install-hint">
      {compact && <button onClick={dismiss} className="absolute top-2 right-2 p-1.5 text-slate-400 hover:text-white" data-testid="install-hint-dismiss" aria-label="Dismiss"><X className="h-4 w-4" /></button>}
      <div className="flex items-start gap-3">
        <span className="h-10 w-10 rounded-lg bg-emerald-500 grid place-items-center text-slate-950 shrink-0"><Smartphone className="h-5 w-5" /></span>
        <div className="min-w-0 text-sm">
          <p className="font-semibold">Add Supplivo to your home screen</p>
          <p className="text-slate-400 mt-0.5">Opens full screen like an app — no address bar, camera ready in one tap.</p>
          {prompt ? (
            <Button onClick={install} size="sm" className="mt-3 bg-emerald-500 text-slate-950 hover:bg-emerald-400" data-testid="install-app-button">Install app</Button>
          ) : isIOS() ? (
            <p className="mt-2 text-slate-300">In Safari tap <Share className="inline h-4 w-4 -mt-0.5" /> <b>Share</b> → <b>Add to Home Screen</b>.</p>
          ) : (
            <p className="mt-2 text-slate-300">In Chrome tap the <b>⋮ menu</b> → <b>Add to Home screen</b> / <b>Install app</b>.</p>
          )}
        </div>
      </div>
    </div>
  );
}
